const WS_WISHLIST_KEY = 'ws_wishlist';

const WsWishlist = {
  getAll() {
    try { return JSON.parse(localStorage.getItem(WS_WISHLIST_KEY) || '[]'); }
    catch { return []; }
  },
  has(id) { return this.getAll().some(p => p.id === id); },
  add(product) {
    const items = this.getAll().filter(p => p.id !== product.id);
    items.push(product);
    localStorage.setItem(WS_WISHLIST_KEY, JSON.stringify(items));
    this._dispatch(product.id, true);
  },
  remove(id) {
    localStorage.setItem(WS_WISHLIST_KEY, JSON.stringify(this.getAll().filter(p => p.id !== id)));
    this._dispatch(id, false);
  },
  toggle(product) { this.has(product.id) ? this.remove(product.id) : this.add(product); },
  count() { return this.getAll().length; },
  _dispatch(id, added) {
    document.dispatchEvent(new CustomEvent('ws:wishlist:change', { detail: { id, added, count: this.count() } }));
  }
};

function _setButtonState(btn, active) {
  btn.classList.toggle('ws-wishlist-btn--active', active);
  btn.setAttribute('aria-label', active ? 'Von Wunschliste entfernen' : 'Zur Wunschliste hinzufügen');
  btn.setAttribute('aria-pressed', String(active));
}

function _updateBadges(count) {
  document.querySelectorAll('.ws-header__wishlist-badge').forEach(el => {
    el.textContent = count;
    count > 0 ? el.removeAttribute('hidden') : el.setAttribute('hidden', '');
  });
}

document.addEventListener('ws:wishlist:change', ({ detail }) => {
  document.querySelectorAll(`[data-wishlist-btn][data-product-id="${detail.id}"]`)
    .forEach(btn => _setButtonState(btn, detail.added));
  _updateBadges(detail.count);
});

function _initButtons() {
  document.querySelectorAll('[data-wishlist-btn]:not([data-wishlist-inited])').forEach(btn => {
    btn.setAttribute('data-wishlist-inited', '');
    const id = parseInt(btn.dataset.productId, 10);
    _setButtonState(btn, WsWishlist.has(id));
    btn.addEventListener('click', () => {
      WsWishlist.toggle({
        id,
        handle: btn.dataset.productHandle,
        title: btn.dataset.productTitle,
        vendor: btn.dataset.productVendor || '',
        price: parseInt(btn.dataset.productPrice, 10) || 0,
        compare_at_price: btn.dataset.productCompareAtPrice ? parseInt(btn.dataset.productCompareAtPrice, 10) : null,
        url: btn.dataset.productUrl,
        image: btn.dataset.productImage || '',
      });
    });
  });
  _updateBadges(WsWishlist.count());
}

document.addEventListener('ws:products-appended', _initButtons);

// --- Wishlist page ---
function _money(cents) {
  return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
}
function _esc(s) {
  return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

function _initWishlistPage() {
  const grid = document.getElementById('WsWishlistGrid');
  const empty = document.getElementById('WsWishlistEmpty');
  const countEl = document.getElementById('WsWishlistCount');
  if (!grid) return;

  function render() {
    const items = WsWishlist.getAll();
    grid.innerHTML = '';
    if (countEl) {
      countEl.textContent = `${items.length} Artikel`;
      items.length > 0 ? countEl.removeAttribute('hidden') : countEl.setAttribute('hidden', '');
    }
    if (items.length === 0) {
      grid.setAttribute('hidden', '');
      empty.removeAttribute('hidden');
      return;
    }
    grid.removeAttribute('hidden');
    empty.setAttribute('hidden', '');

    items.forEach(p => {
      const priceHtml = (p.compare_at_price && p.compare_at_price > p.price)
        ? `<span class="ws-card__price-sale">${_money(p.price)}</span>&nbsp;<span class="ws-card__price-original">${_money(p.compare_at_price)}</span>`
        : _money(p.price);
      const imgHtml = p.image
        ? `<img src="${_esc(p.image)}" alt="${_esc(p.title)}" class="ws-card__img" loading="lazy">`
        : `<div class="ws-card__img-placeholder"></div>`;

      grid.insertAdjacentHTML('beforeend', `
        <div class="ws-card ws-wishlist__card">
          <div class="ws-card__img-wrap">
            <a href="${_esc(p.url)}" class="ws-card__overlay-link" tabindex="-1" aria-hidden="true"></a>
            ${imgHtml}
            <button type="button" class="ws-wishlist__remove-btn" aria-label="Von Wunschliste entfernen" data-remove-id="${p.id}">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <span class="ws-card__brand">${_esc(p.vendor)}</span>
          <a href="${_esc(p.url)}" class="ws-card__title">${_esc(p.title)}</a>
          <span class="ws-card__price">${priceHtml}</span>
        </div>
      `);
    });

    grid.querySelectorAll('[data-remove-id]').forEach(btn => {
      btn.addEventListener('click', () => { WsWishlist.remove(parseInt(btn.dataset.removeId, 10)); render(); });
    });
  }

  render();
}

document.addEventListener('DOMContentLoaded', () => { _initButtons(); _initWishlistPage(); });
